import { render, staticRenderFns } from "./ContentSelector.vue?vue&type=template&id=2efb216b"
import script from "./ContentSelector.vue?vue&type=script&lang=js"
export * from "./ContentSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports